import { sendGA4Event } from "analytics/ga4-helper";
import axios from "fetch-api/fetch-api";
import { IConvertedJpeg } from "./interfaces/get-converted-jpeg.type";

export function getConvertedJpeg(url: string, isSecondAttempt?: boolean) {
  if (url.indexOf("data:image/jpeg;base64") >= 0) {
    return new Promise((resolve, reject) => {
      reject(new Error("data image cannot be converted via api"));
    });
  }
  return axios.get<IConvertedJpeg>(`s/get-converted-jpeg?url=${url}`)
    .then(({ data }) => {
      if (!data.success && !isSecondAttempt) {
        sendGA4Event("catch_get_converted_jpeg_failed", {
          url,
        });
        return setTimeout(() => getConvertedJpeg(url, true), 1000);
      }
      return btoa(String.fromCharCode.apply(null, new Uint8Array(data.jpegBytes)));
    }).catch(() => {
      if (isSecondAttempt) {
        return "";
      }
      return setTimeout(() => getConvertedJpeg(url, true), 1000);
    });
}
